import { Enums } from '../enums/enums';

export class NavigationRoutes {

    static readonly landingPage = {
        path: '',
        title: 'Aauto',
        navigationPath: '',
    }

    private static readonly sideNavPath = 'admin';
    private static readonly campaignPath = 'campaign';
    static readonly sideNav = {
        path: NavigationRoutes.sideNavPath,
        title: 'Home',
        navigationPath: 'admin',
        children:
        {
            dashboard: {
                path: 'dashboard',
                title: 'Dashboard',
                navigationPath: `${NavigationRoutes.sideNavPath}/dashboard`
            },
            campaignAdd: {
                path: `${NavigationRoutes.campaignPath}/add`,
                title: 'Add campaign',
                navigationPath: `${NavigationRoutes.sideNavPath}/${NavigationRoutes.campaignPath}/add`
            },
            campaignList: {
                path: NavigationRoutes.campaignPath,
                title: 'Campaign',
                navigationPath: `${NavigationRoutes.sideNavPath}/${NavigationRoutes.campaignPath}`
            },
            campaignDetails: {
                path: `${NavigationRoutes.campaignPath}/:organizationId/:campaignId`,
                title: 'Campaign details',
                navigationPath: `${NavigationRoutes.sideNavPath}/${NavigationRoutes.campaignPath}`
            },
            campaignInsights: {
                path: `campaign-insights/:organizationId/:campaignId`,
                title: 'Campaign Insights',
                navigationPath: `${NavigationRoutes.sideNavPath}/campaign-insights`
            }
        },
    }

    static readonly rightDrawer = {

        campaignCreateMaster: {
            path: 'campaign-create-master/:organizationId/:campaignId',
            navigationPath: `campaign-create-master`
        },
        campaignTypeSelector: {
            path: 'campaign-type',
            navigationPath: `campaign-type`
        },
        geolocationDetails: {
            path: 'geolocation-details',
            navigationPath: `geolocation-details`
        },
        notificationDetails: {
            path: 'notification-details',
            navigationPath: `notification-details`
        },
        sendNotificationCreateMaster: {
            path: 'send-notification-create-master/:organizationId/:campaignId',
            navigationPath: `send-notification-create-master`
        },
    }

    private static readonly viewerPath = 'view';
    static readonly viewers = {
        path: NavigationRoutes.viewerPath,
        title: 'Aauto',
        navigationPath: NavigationRoutes.viewerPath,
        children:
        {
            audioViewer: {
                path: `${Enums.MediaTypes.Audio}/:organizationId/:campaignId`,
                title: 'Audio',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Audio}`
            },
            competition: {
                path: `${Enums.MediaTypes.Competition}/:organizationId/:campaignId`,
                title: 'Competition',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Competition}`
            },
            facebookViewer: {
                path: `${Enums.MediaTypes.Facebook}/:organizationId/:campaignId`,
                title: 'Facebook',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Facebook}`
            },
            imageViewer: {
                path: `${Enums.MediaTypes.Images}/:organizationId/:campaignId`,
                title: 'Images',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Images}`
            },
            instagramViewer: {
                path: `${Enums.MediaTypes.Instagram}/:organizationId/:campaignId`,
                title: 'Instagram',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Instagram}`
            },
            linkedInViewer: {
                path: `${Enums.MediaTypes.LinkedIn}/:organizationId/:campaignId`,
                title: 'Linked In',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.LinkedIn}`
            },
            menuViewer: {
                path: `${Enums.MediaTypes.InteractiveMenu}/:organizationId/:campaignId`,
                title: 'Menu',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.InteractiveMenu}`
            },
            pdfViewer: {
                path: `${Enums.MediaTypes.PDF}/:organizationId/:campaignId`,
                title: 'Document',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.PDF}`
            },
            pinterestViewer: {
                path: `${Enums.MediaTypes.Pinterest}/:organizationId/:campaignId`,
                title: 'Pinterest',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Pinterest}`
            },
            redirectViewer: {
                path: `${Enums.MediaTypes.Redirect}/:organizationId/:campaignId`,
                title: 'Redirect',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Redirect}`
            },
            subscriptionCampaignViewer: {
                path: `${Enums.MediaTypes.SubscriptionCampaign}/:organizationId/:campaignId`,
                title: 'Subscription Campaign',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.SubscriptionCampaign}`
            },
            tiktokViewer: {
                path: `${Enums.MediaTypes.TikTok}/:organizationId/:campaignId`,
                title: 'Tiktok',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.TikTok}`
            },
            videoViewer: {
                path: `${Enums.MediaTypes.Video}/:organizationId/:campaignId`,
                title: 'Video',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Video}`
            },
            webPageViewer: {
                path: `${Enums.MediaTypes.WebPage}/:organizationId/:campaignId`,
                title: 'Web Page',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.WebPage}`
            },
            xViewer: {
                path: `${Enums.MediaTypes.X}/:organizationId/:campaignId`,
                title: 'X',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.X}`
            },
            youTubeViewer: {
                path: `${Enums.MediaTypes.Youtube}/:organizationId/:campaignId`,
                title: 'YouTube',
                navigationPath: `${NavigationRoutes.viewerPath}/${Enums.MediaTypes.Youtube}`
            }
        }
    }

    private static readonly scannerPath = 'scanner';
    static readonly scanners = {
        path: NavigationRoutes.scannerPath,
        title: 'Aauto',
        navigationPath: NavigationRoutes.scannerPath,
        children:
        {
            receiptScanner: {
                path: `${Enums.ScannerTypes.Receipt}/:organizationId/:campaignId`,
                title: 'Receipt Scanner',
                navigationPath: `${NavigationRoutes.scannerPath}/${Enums.ScannerTypes.Receipt}`
            }
        }
    }

    static readonly pageNotFound = {
        path: '**',
        title: 'Not Found',
        navigationPath: 'not-found'
    }
}